import Legenda from "app/components/itens-orcamento/legenda/Legenda"
import React from "react"

export const LegendaDisponibilidadeCapacidadeDeCarga = () => {
    return <>
        <Legenda
            itens={[
                {
                    nome: "Data Disponível",
                    cor: "var(--mu-azul-solido, #0000FF)"
                },
                {
                    nome: "Data Sem Cadastro",
                    cor: "#008000"
                },
                {
                    nome: "Data Indisponível",
                    cor: "red"
                }
            ]} />
    </>
}